<div class="content">
    <form #kundenbetreuerCreateForm="ngForm" data-qa="settings-kundenbetreuer-create-form">

        <header>
            <div>
            </div>

            <div class="buttons">

                <button matButton="outlined"
                        type="button"
                        data-qa="close-details-button"
                        (click)="westnetzSidenavService.closeRightnav()">
                    <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                    Schließen
                </button>

                <button matButton="filled"
                        [disabled]="!kundenbetreuerCreateForm.form.valid"
                        type="button"
                        data-qa="create-kundenbetreuer-button"
                        (click)="saveKundenbetreuer()">
                    <mat-icon>save</mat-icon>
                    {{ createNew ? 'Anlegen' : 'Speichern' }}
                </button>

                @if (!createNew) {
                    <button matButton="filled"
                            type="button"
                            class="button-warn"
                            data-qa="delete-kundenbetreuer-button"
                            (click)="deleteKundenbetreuer(kundenbetreuer)">
                        <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                        Löschen
                    </button>
                }

            </div>
        </header>

        <div class="detail-main">

            <fieldset>
                <legend>Kundenbetreuer {{ createNew ? 'anlegen' : 'editieren' }}</legend>

                <mat-form-field>
                    <mat-label>Vorname</mat-label>
                    <input matInput
                           maxlength="100"
                           #vorname="ngModel"
                           data-qa="vorname"
                           [(ngModel)]="kundenbetreuer.vorname"
                           id="vorname"
                           name="vorname"
                           required/>
                    @if (vorname?.errors?.required) {
                        <mat-error>
                            Bitte tragen Sie den Vornamen des Kundenbetreuers ein
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Nachname</mat-label>
                    <input matInput
                           maxlength="100"
                           #nachname="ngModel"
                           data-qa="nachname"
                           [(ngModel)]="kundenbetreuer.nachname"
                           id="nachname"
                           name="nachname"
                           required/>
                    @if (nachname?.errors?.required) {
                        <mat-error>
                            Bitte tragen Sie den Nachnamen des Kundenbetreuers ein
                        </mat-error>
                    }
                </mat-form-field>

            </fieldset>
        </div>
    </form>
</div>
